import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CContainer, CHeader, CHeaderBrand, CHeaderNav, CHeaderToggler } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilMenu } from '@coreui/icons'

import { AppBreadcrumb } from './index'
import { AppHeaderDropdown } from './header/index'

const AppHeader = () => {
  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)

  return (
    <CHeader position="sticky" className="mb-4">
      <CContainer fluid>
        <CHeaderToggler
          className="ps-1"
          onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        <CHeaderBrand className="mx-auto d-md-none" to="/">
          <div className="d-flex align-items-center gap-2 fw-bold" aria-label="FusionPhish brand">
            <svg
              className="logo-img"
              width="38"
              height="38"
              viewBox="0 0 200 200"
              role="img"
              aria-label="Fusion logo"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Fusion</title>
              <path
                d="M20 20 H180 V130 Q180 170 100 182 Q20 170 20 130 Z"
                fill="#ffffff"
                stroke="#cfd7e6"
                strokeWidth="16"
              />
              <rect x="32" y="32" width="136" height="36" rx="4" fill="#4585C5" />
              <path d="M32 84 H94 V168 Q58 166 41 146 Q32 135 32 120 Z" fill="#050707" />
              <rect x="110" y="84" width="58" height="36" rx="3" fill="#050707" />
            </svg>
            <span className="fs-5">Fusion</span>
          </div>
        </CHeaderBrand>
        <AppBreadcrumb />
        {/*
        <CHeaderNav className="d-none d-md-flex me-auto">
          <CNavItem>
            <CNavLink to="/dashboard" component={NavLink}>
              Dashboard
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#">Users</CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#">Settings</CNavLink>
          </CNavItem>
        </CHeaderNav>
        */}
        <CHeaderNav className="ms-3">
          {/*
          <CNavItem>
            <CNavLink href="#">
              <CIcon icon={cilBell} size="lg" />
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink href="#">
              <CIcon icon={cilEnvelopeOpen} size="lg" />
            </CNavLink>
          </CNavItem>
          */}
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
      {/*
      <CHeaderDivider />
      <CContainer fluid>
        <AppBreadcrumb />
      </CContainer>
      */}
    </CHeader>
  )
}

export default AppHeader
